/*  反馈接口  */
const _import = require("../_import");

export default [
  {
    path: "/",
    name: "home",
    meta: { title: "首页", from: 1 },
    component: _import("index")
  }
];
